<template>
  <div class="app-screen">
    <div :class="classObj" class="app-wrapper app-layout">
      <!-- 头部 -->
      <div class="app-header app-layout">
        <i 
        :class="[sidebarCollapse?'logo-little':'logo-big',$store.state.app.language,'app-logo']"
        style="text-align: center"
        >
          <svg-icon icon-class="logo" 
          :style="{
            fontSize: sidebarCollapse ? '50px !important':'110px !important',
            marginTop: sidebarCollapse ? '6px':'-23px',
            }"></svg-icon>
        </i>
        <div class="app-header-right">
          <hamburger />
          <div class="app-breadcrumb el-breadcrumb" />
          <app-map v-if="fullscreen" :params="fullscreenParams" class="can-hover" />
          <app-task class="can-hover" v-if="this.$store.state.user.userInfo.monitorfirstaid"/>
          <!-- <theme class="can-hover" /> -->
          <headersetting />
          <lang-select />
          <!-- <size class="can-hover" /> -->
          <!-- <div class="can-hover" style="width:40px;height:40px" @click="toMap">
            <svg-icon icon-class="icon-map"></svg-icon>
          </div> -->
        </div>
      </div>
      <!-- 布局 -->
      <div class="app-body app-layout">
        <sidebar :class="[$store.state.app.language,'app-sidebar']" />
        <div class="app-main-wrapper app-layout">
          <tags-view />
          <app-main />
          <!-- <footer class="app-footer">
            <div class="antd-pro-components-global-footer-index-copyright">Copyright 2018 兴民智通软件部</div>
          </footer> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { mapGetters } from 'vuex'
import { Sidebar, AppMain, TagsView } from './components'
import Hamburger from '@/components/Hamburger'
import Headersetting from '@/components/HeaderSetting'
// import Theme from '@/components/Theme'
// import Size from '@/components/Size'
import AppMap from '@/components/map'
import AppTask from '@/components/task'
import LangSelect from '@/components/LangSelect'
import { mapGetters } from 'vuex'
export default {
  name: 'Layout',
  components: {
    Hamburger,
    Headersetting,
    // Theme,
    Sidebar,
    AppMain,
    TagsView,
    AppMap,
    LangSelect,
    AppTask
  },
  data() {
    return {
      searchActive: false
    }
  },
  computed: {
    animation() {
      return this.$store.state.app.animation
    },
    sidebarCollapse() {
      return this.$store.state.app.sidebarCollapse
    },
    fullscreen() {
      return this.$store.state.permission.fullscreenMap
    },
    fullscreenParams() {
      return this.$store.state.permission.mapParams
    },
    classObj() {
      return {
        'animation': this.animation,
        'collapse': this.sidebarCollapse,
        'search-active': this.searchActive
      }
    },
    ...mapGetters([
      'addRealRouters'
    ])

  },
  methods: {
  }

}
</script>
<style lang="scss">
// 注册主题
@import '@/styles/theme/register.scss';
</style>
